// @ts-nocheck — W8.2: entry point migrado de index.js para main.tsx
import "@mantine/core/styles.css";
import "@mantine/notifications/styles.css";
import "@mantine/dates/styles.css";
import "./theme/typography.css";

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { Provider as ReduxProvider } from "react-redux";
import { MantineProvider } from "@mantine/core";
import { Notifications } from "@mantine/notifications";
import { ModalsProvider } from "@mantine/modals";
import { BrowserRouter } from "react-router-dom";

import { store } from "./store";
import { theme } from "./theme";
import App from "./App";

const basename = import.meta.env.REACT_APP_BASENAME ?? "/";
const rootEl = document.getElementById("root");

if (!rootEl) {
  throw new Error("root element não encontrado em index.html");
}

createRoot(rootEl).render(
  <StrictMode>
    <ReduxProvider store={store}>
      <MantineProvider theme={theme} defaultColorScheme="light">
        <ModalsProvider>
          <Notifications position="top-right" />
          <BrowserRouter basename={basename}>
            <App />
          </BrowserRouter>
        </ModalsProvider>
      </MantineProvider>
    </ReduxProvider>
  </StrictMode>,
);
